import React, { useMemo, useState } from "react";

import TrendToolbar from "./TrendToolbar";
import TrendChart from "./TrendChart";

import {
    buildDailyTrend,
    buildCumulativeTrend
} from "./TrendUtils";

const TrendView = ({ list, selectedOrg, loading, error }) => {

    const [period, setPeriod] = useState("weekly");

    const [metric, setMetric] = useState("daily");

    const [chartType, setChartType] = useState("bar");

    // 图表数据

    const trendData = useMemo(() => {

        switch (metric) {

            case "daily":

                return buildDailyTrend(
                    list,
                    period,
                    selectedOrg
                );

            default:

                return buildCumulativeTrend(
                    list,
                    period,
                    selectedOrg
                );

        }

    }, [list, period, metric, selectedOrg]);

    if (loading) {
        return (
            <div className="table-container">
                <div className="loading">
                    Loading...
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="table-container">
                <div className="error-banner">
                    {error?.message || String(error)}
                </div>
            </div>
        );
    }
    return (

        <div>

            <TrendToolbar

                period={period}

                setPeriod={setPeriod}

                metric={metric}

                setMetric={setMetric}

                chartType={chartType}

                setChartType={setChartType}

            />

            <TrendChart

                trendData={trendData}

                selectedOrg={selectedOrg}

                chartType={chartType}

                metric={metric}

            />

        </div>

    );

};

export default TrendView;